import { useCallback } from 'react';
import { setCookie } from '@/helpers/common';
import { COOKIE_NAME } from '@/helpers/cookie';
import type { INDBLandingCode } from '@/modules/promo/hooks/useLandingNDBFlow';
import { STORAGE, useLocalStorageStore } from '@/store';
import { useSaveUserStorageItems } from '@/store/serverUserStorage';
import { SERVER_USER_STORAGE_IDENTIFIER } from '@/store/serverUserStorage/helpers';

const NDB_LANDING_COOKIE_EXPIRES_DAYS = 7; // matches usePromoRedirect's exemption window

export const useSyncUserLPCoupon = () => {
  const { saveUserStorageItems } = useSaveUserStorageItems();

  const syncUserLPCoupon = useCallback(() => {
    const ndbLandingCode = useLocalStorageStore
      .getState()
      .get<INDBLandingCode | null>(STORAGE.NDB_LANDING_CODE);

    saveUserStorageItems([
      {
        identifier: SERVER_USER_STORAGE_IDENTIFIER.NDB_LANDING_COUPON,
        info: {
          coupon: ndbLandingCode?.coupon,
        },
      },
    ]);

    if (ndbLandingCode?.initialCode) {
      // Lets withPromo.ts (server middleware) recognize the landing this
      // account registered on and skip its redirect for that one landing.
      setCookie(
        COOKIE_NAME.NDB_LANDING,
        ndbLandingCode.initialCode,
        NDB_LANDING_COOKIE_EXPIRES_DAYS
      );
    }
  }, [saveUserStorageItems]);

  return { syncUserLPCoupon };
};
